import { css } from '@emotion/core'
import * as React from 'react'

import { headerBreakPoint } from '../constants/breakPoints'
import { breakpoints } from '../constants/breakPoints'
import { headerHeight } from '../constants/header'
import { searchBarHeight } from './Search'

interface LoadingComponentProps {
  small?: boolean
  width?: string
  blackBG?: boolean
}

export const LoadingSpinner: React.FunctionComponent<LoadingComponentProps> = ({
  small = false,
  blackBG = false,
  width = small ? '16px' : '64px',
}) => {
  return (
    <div css={loadingContainerStyle(blackBG, small)}>
      <div css={loadingSpinnerStyle(small, width)} />
    </div>
  )
}

const loadingContainerStyle = (blackBG: boolean, small?: boolean) => css`
  ${!small &&
  `
    position: fixed;   
    top: ${headerHeight}px;
    left: 0;
    height: calc(100vh - ${headerHeight}px);
  `};

  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${blackBG ? 'transparent' : 'rgba(255, 255, 255, 0.5)'};
  backdrop-filter: blur(20px);
  z-index: 4;

  @media screen and (max-width: ${breakpoints.medium}px) {
    ${!small && `align-items: flex-start; padding-top: 20vh`};
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    ${!small &&
    `
      align-items: flex-start; 
      padding-top: ${headerHeight + searchBarHeight}px}
    `};
  }
`

const loadingSpinnerStyle = (small: boolean, width: string) => css`
  ${!small && `margin-bottom: ${headerHeight}px`};
  width: ${width};
  height: ${width};
  border: ${small ? '1px' : '4px'} solid;
  border-color: #318eff transparent #318eff transparent;
  border-radius: 50%;
  animation: spin-anim 1.2s linear infinite;

  @media screen and (max-width: ${headerBreakPoint}px) {
    ${!small && `margin-bottom: 0`};
  }

  @keyframes spin-anim {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const LoadingRing: React.FunctionComponent<LoadingComponentProps> = ({ width = '96px', small = false }) => {
  return (
    // loadingContainerStyle from above
    <div css={[loadingContainerStyle(small), loadingRingContainerStyle(width)]}>
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}

const loadingRingContainerStyle = (width: string) => css`
  &:before,
  &:after {
    position: absolute;
    margin: auto;
    width: ${width};
    height: ${width};
    content: '';
    border-radius: 50%;
    inset: 0;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3) inset;
  }

  &:after {
    box-shadow: 0 2px 0 #318eff inset;
    animation: rotate 2s linear infinite;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
